import _ from 'underscore';
import { cloneDeep } from '@bingads-webui-universal/primitive-utilities';

import { Deserializer } from './deserializer';
import { SessionFilterStorage } from './session-filter-storage';
import { taskQueueMixin } from './task-queue-mixin';
import type { FilterObject, FilterStorageId, FilterStorageOptions } from './types';

export class EditableFilterStorage extends SessionFilterStorage {
  deserializer: Deserializer;

  constructor(options: FilterStorageOptions = {}) {
    super(options);
    this.deserializer = new Deserializer(options);

    taskQueueMixin(this, ['get', 'save', 'clean']);
  }

  /**
   * @private
   * @return {Object} - resource and entry ids
   */
  getSessionStorageId({
    featureName,
    entityName,
  }: { featureName?: string; entityName?: string }): FilterStorageId {
    // Resource id is for defining resource
    // Entry id is for defining each entry under the same resource
    return {
      resourceId: `editable-filter-storage-campaignwebui-${featureName}`,
      entryId: `${entityName}/EditableFilter`,
    };
  }

  /**
   * @returns {Object} Promise that resolve to Filter object that contains query,
   * name and id
  */
  get() {
    return this.storage.find(this.entryId)
      .then((result = {}) => {
        try {
          if (_.isObject(result) && result.filter) {
            const savedFilter = result.filter;

            const filter = _.isString(savedFilter) ?
              this.deserializer.deserialize(JSON.parse(savedFilter)) :
              this.deserializer.deserialize(cloneDeep(savedFilter));

            return !_.isEmpty(filter.query) ? { filter } : {};
          }
          return JSON.parse(result);
        } catch (err) {
          throw new Error('Invalid filter JSON string');
        }
      })
      .catch(() => ({}));
  }

  /**
   * Save quick filter key and query to session
   * @param {Object} filter - Filter object that contains query, name and id
   * @return {undefined}
   */
  save(filter: FilterObject) {
    return this.storage.create({
      id: this.entryId,
      filter: JSON.stringify(_.pick(filter, 'query', 'name', 'id')),
    });
  }
}
